import * as React from 'react';
import { ProductionSchedule } from '../../schedule-cdoem/views/Schedule';

/**
 * The schedule of the runs with a Rolling Steel order.  Their one metric is the loading one (MISC), which prints their
 * production paperwork.
 */
export const ProductionScheduleRsScene = () => <ProductionSchedule group="rs" />;
